<template>
  <SForm @submit="$emit('submit')">
    <v-row class="mx-2 filter-bar">
      <slot name="prepend" />
      <v-col v-for="field in fields" :key="field.key" cols="12" sm="4">
        <SSelect
          v-if="field.type === 'select'"
          :value="value[field.key]"
          :label="field.label"
          :items="field.items"
          :item-text="field.itemText"
          :item-value="field.itemValue"
          :multiple="field.multiple"
          hide-details
          @input="update(field.key, $event)"
        />
        <STextField
          v-else
          :value="value[field.key]"
          :label="field.label"
          :type="field.type === 'date' ? 'date' : 'text'"
          hide-details
          @input="update(field.key, $event)"
        />
      </v-col>
      <v-col cols="auto" class="ml-auto d-flex align-center">
        <SBtn type="submit" label="Search" :loading="loading" />
      </v-col>
    </v-row>
  </SForm>
</template>

<script>
export default {
  props: {
    fields: { type: Array, required: true },
    value: { type: Object, required: true },
    loading: { type: Boolean, default: false },
  },
  methods: {
    update(key, val) {
      this.$emit('input', { ...this.value, [key]: val })
    },
  },
}
</script>
